import { BorrowerType, DocumentCategory } from '../constants'
import { createCustomEntityId, parseCustomEntityId } from '../utils'

export const getIsOperatingCompany = (customEntityId) =>
  parseCustomEntityId(customEntityId).borrowerType === BorrowerType.oc

export const getIsFinancialCategory = (category) =>
  category === DocumentCategory.business_financial_and_underwriting

export const formatEntities = (entities) =>
  entities.map((entity) => ({
    customId: createCustomEntityId(entity),
    name: entity.name,
  }))
